<script lang="ts" setup>
import type { FooterMenu } from '~/types/app'
import { REGISTER_INSTRUCTION } from '~/resources/instruction'
import { AuthTabEnum, RoutesEnum } from '~/enums'

defineProps({
  item: {
    type: Object as () => FooterMenu,
    required: true,
  },
  isExpanded: {
    type: Boolean,
    required: true,
  },
  largeGrid: {
    type: Boolean,
    default: false,
  },
})

const authStore = useAuthStore()
const { openAuthModal } = useAuth()
const { isLogged } = useUser()

const openModalWithRegister = () => {
  authStore.setSelectedAuthTab(AuthTabEnum.Register)
  openAuthModal()
}

type DoneCallback = () => void

const emit = defineEmits(['toggle'])

const toggle = () => {
  emit('toggle')
}
const beforeEnter = (el: HTMLElement) => {
  el.style.opacity = '0'
}
const enter = (el: HTMLElement, done: DoneCallback) => {
  el.style.transition = 'opacity 0.8s'
  el.style.opacity = '1'
  done()
}
const leave = (el: HTMLElement, done: DoneCallback) => {
  el.style.transition = 'opacity 0.8s'
  el.style.opacity = '0'
  done()
}
const { isOpenInstruction, toggleInstruction } = useInstruction()
</script>

<template>
  <div class="mobile-item-collapse">
    <div class="item-collapse__header" @click="toggle">
      <div class="item-collapse__header__title">
        <div>{{ item.title }}</div>
      </div>
      <div v-if="isExpanded" class="item-collapse__header__arrow">
        <span class="icon-up"></span>
      </div>
      <div v-else class="item-collapse__header__arrow">
        <span class="icon-down"></span>
      </div>
    </div>
    <transition
      name="fade"
      @on-before-enter="beforeEnter"
      @on-enter="enter"
      @on-leave="leave"
    >
      <ul
        v-if="isExpanded"
        :class="{
          'item-collapse__menu': true,
          'item-collapse__menu--large-grid': $props.largeGrid,
        }"
      >
        <li
          v-for="sub in item.menus"
          :key="sub.to"
          class="item-collapse__menu__item"
        >
          <template v-if="sub.to === RoutesEnum.InstructRegister">
            <div
              class="item-collapse__menu__item--link cursor-pointer"
              @click="toggleInstruction()"
            >
              {{ sub.title }}
            </div>
          </template>
          <template v-else>
            <NuxtLink class="item-collapse__menu__item--link" :to="sub.to">
              {{ sub.title }}
            </NuxtLink>
          </template>
        </li>
      </ul>
    </transition>
    <div class="item-collapse__divider"></div>
  </div>
  <ModalCommonInstruction
    v-model="isOpenInstruction"
    :data="REGISTER_INSTRUCTION"
    :on-finished="openModalWithRegister"
    :disable-final="isLogged"
    final-step-label="Đăng ký"
  />
</template>

<style scoped>
@import '~/assets/styles/components/mobile/footer/item-collapse.scss';
</style>
